<template>
  <div class="cr-arguments-editor">
    <v-card
      v-for="(arg, argIndex) in argumentsList"
      :key="argIndex"
      outlined
      class="mb-3 pa-3"
    >
      <div class="d-flex align-center mb-2">
        <span class="text-subtitle-2 font-weight-medium">
          Аргумент {{ argIndex + 1 }}
        </span>
        <v-spacer />
        <btn-with-confirm
          v-if="!readonly && argumentsList.length > 1"
          icon
          small
          color="error"
          icon-main="mdi-delete-outline"
          icon-small
          title="Удалить аргумент"
          @click="removeArgument(argIndex)"
        />
      </div>
      <v-select
        v-model="arg.type"
        :items="CR_ARGUMENT_TYPES"
        item-text="text"
        item-value="value"
        label="Тип аргумента"
        dense
        :outlined="!readonly"
        :readonly="readonly"
        hide-details
        class="mb-3"
        @change="emitChange()"
      />
      <v-textarea
        v-model="arg.text"
        label="Текст аргумента"
        :rows="10"
        no-resize
        auto-grow
        :outlined="!readonly"
        :readonly="readonly"
        hide-details
        class="mb-3"
        @input="emitChange()"
        @blur="$emit('blur')"
      />
      <v-switch
        v-if="!readonly"
        v-model="arg.hasUurUdd"
        label="Наличие УУР и УДД"
        hide-details
        dense
        class="mt-0 mb-2"
        @change="onUurUddToggle(arg)"
      />
      <div v-else-if="arg.hasUurUdd" class="text-caption mb-2">
        УУР и УДД: {{ formatArgumentUurUdd(arg.udd, arg.uur) || '—' }}
      </div>
      <v-row v-if="arg.hasUurUdd" dense>
        <v-col cols="6">
          <v-select
            v-model="arg.udd"
            :items="CR_UDD_ITEMS"
            label="УДД"
            dense
            :outlined="!readonly"
            :readonly="readonly"
            clearable
            hide-details
            @change="emitChange()"
          />
        </v-col>
        <v-col cols="6">
          <v-select
            v-model="arg.uur"
            :items="CR_UUR_ITEMS"
            label="УУР"
            dense
            :outlined="!readonly"
            :readonly="readonly"
            clearable
            hide-details
            @change="emitChange()"
          />
        </v-col>
        <v-col v-if="!readonly" cols="12">
          <div class="text-caption text--secondary">
            1A–2C — убедительные доказательства; 3C–4C — недостаточная
            убедительность; 5C — экспертное мнение.
          </div>
        </v-col>
      </v-row>
    </v-card>
    <div v-if="!readonly" class="text-right">
      <v-btn color="accent" fab small @click="addArgument">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import BtnWithConfirm from '@/components/buttons/btnWithConfirm'
import {
  CR_ARGUMENT_TYPES,
  CR_UDD_ITEMS,
  CR_UUR_ITEMS,
  DEFAULT_CR_ARGUMENT,
  formatArgumentUurUdd,
} from '@/components/expSummary/summaryCrPresence/crPresenceConst'

export default {
  name: 'CrArgumentsEditor',
  components: { BtnWithConfirm },
  props: {
    value: { type: Array, default: () => [] },
    readonly: { type: Boolean, default: false },
  },
  data: () => ({
    CR_ARGUMENT_TYPES,
    CR_UDD_ITEMS,
    CR_UUR_ITEMS,
    argumentsList: [],
  }),
  watch: {
    value: {
      immediate: true,
      handler: 'init',
    },
  },
  methods: {
    formatArgumentUurUdd,
    init() {
      const src = Array.isArray(this.value) ? this.value : []
      this.argumentsList = src.length
        ? src.map(a => ({ ...DEFAULT_CR_ARGUMENT(), ...a }))
        : [{ ...DEFAULT_CR_ARGUMENT() }]
    },
    onUurUddToggle(arg) {
      if (!arg.hasUurUdd) {
        arg.udd = null
        arg.uur = null
      }
      this.emitChange()
    },
    addArgument() {
      this.argumentsList.push({ ...DEFAULT_CR_ARGUMENT() })
      this.emitChange(true)
    },
    removeArgument(index) {
      this.argumentsList.splice(index, 1)
      this.emitChange(true)
    },
    emitChange(force = false) {
      this.$emit(
        'change',
        this.argumentsList.map(a => ({ ...a })),
        force
      )
    },
  },
}
</script>
